import { render } from "./SocialNetworkCard.vue.js?vue&type=template&id=79afd9ae&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SocialNetworkCard.vue?vue&type=template&id=79afd9ae&scoped=true"
import script from "./SocialNetworkCard.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SocialNetworkCard.vue?vue&type=script&lang=js"
export * from "./SocialNetworkCard.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SocialNetworkCard.vue?vue&type=script&lang=js"

import "./SocialNetworkCard.vue.scss?vue&type=style&index=0&id=79afd9ae&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SocialNetworkCard.vue?vue&type=style&index=0&id=79afd9ae&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79afd9ae"],['__file',"src/Web/scripts/components/social-networks/SocialNetworkCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79afd9ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79afd9ae', __exports__)) {
    api.reload('79afd9ae', __exports__)
  }
  
  module.hot.accept("./SocialNetworkCard.vue.js?vue&type=template&id=79afd9ae&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SocialNetworkCard.vue?vue&type=template&id=79afd9ae&scoped=true", () => {
    api.rerender('79afd9ae', render)
  })

}


export default __exports__